<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("users/getDoctors");
    this.$store.dispatch("users/getEmployees");
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    userTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.UserTypes
      );
    },

    doctors() {
      return this.$store.state.users.doctors;
    },
    employees() {
      return this.$store.state.users.employees;
    },
    features() {
      return this.$store.state.users.features;
    },

  },
  data() {
    return {
      vm: {
        userTypeId: null,
        loginName: null,
        password: null,
        employeeId: null,
        doctorId: null,
        permissions: [],
      },

      isPasswordVisible: false,

    };
  },
  methods: {
    getFeatures() {
      this.$store.dispatch("users/getFeatures", this.vm.userTypeId);
    },
    onFileUpload(file) {
      // Handle the file upload logic here
      console.log("File uploaded:", file);
    },
    confirm() {
      this.$store
        .dispatch("users/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    back() {
      this.$emit("back");
    },
    CheckAll(feature) {
      feature.permissions.forEach((permission) => {
        if (feature.checkAll) {
          if (!this.vm.permissions.includes(permission.permissionId)) {
            this.vm.permissions.unshift(permission.permissionId);
          }
        } else {
          if (this.vm.permissions.includes(permission.permissionId)) {
            let index = this.vm.permissions.indexOf(permission.permissionId);
            this.vm.permissions.splice(index, 1);
          }
        }
      });
    },

    HandleChange(feature) {
      feature.checkAll = true;
      feature.permissions.forEach((permission) => {
        if (!this.vm.permissions.includes(permission.permissionId)) {
          feature.checkAll = false;
        }
      });
    },

  },
};
</script>